import script from "./StepDuration.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepDuration.vue?vue&type=script&setup=true&lang=ts"

import "./StepDuration.vue?vue&type=style&index=0&id=64f6b622&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f6b622"]])

export default __exports__